import styled from 'styled-components';

export const UserMenuWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
`;

export const UserMenuText = styled.p`
  font-weight: 700;
  color: #757575;
`;
